export const PATIENT_ADDRESS_TYPE = {
  home: 'HOME',
  work: 'WORK',
};
